export default "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvVcAAAAdQjYp0pv+BiOh/AAA="